import { hubReducer } from './hubReducer';
import { collectionsReducer } from './collectionsReducer';
import { combineReducers } from "redux";

const paperfliteReducer = combineReducers({
  streams: hubReducer,
  collections: collectionsReducer
});

export { paperfliteReducer };